import { useEffect, useRef, useState } from "react";
import Header from "../components/HeaderThree";

import ProjectNew from "../components/ProjectNew";
import { motion } from "framer-motion";
import { executiveData } from "../data/leadershipData";
import TrustIcon from "../assets/icons/trusted-seller.png";
import EmpathyIcon from "../assets/icons/customer-engagement.png";
import CreativityIcon from "../assets/icons/creativity.png";



export default function ProjectUspage() {
    const bgRef = useRef(null);
    const sectionRef = useRef(null);

    const [activeTab, setActiveTab] = useState("executive");
    const [leaders, setLeaders] = useState(executiveData);
    const [index, setIndex] = useState(0);

    const capabilitiesHeading =
        "Personalized home solutions, designed exclusively for you."
            .split(" ");


    useEffect(() => {
        const handleScroll = () => {
            if (!sectionRef.current || !bgRef.current) return;

            const rect = sectionRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Calculate progress based on scroll
            const progress = Math.min(
                Math.max((windowHeight - rect.top) / (windowHeight + rect.height), 0),
                1
            );

            // Apply scale transformation to background image
            const scale = 1 + progress * 0.3; // 1 → 1.3
            bgRef.current.style.transform = `scale(${scale})`;

            // Prevent horizontal scrolling by containing the image
            bgRef.current.style.width = "100%";
            bgRef.current.style.maxWidth = "100vw";
            bgRef.current.style.overflow = "hidden";
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const [selectedLeader, setSelectedLeader] = useState(null);

    /* reset line when tab changes */
    const switchTab = (tab) => {
        setActiveTab(tab);
        setLeaders(tab === "executive");
        setIndex(0);
    };

    const visibleSlides = 4;
    const maxIndex = leaders.length - visibleSlides;
    const progress = maxIndex <= 0 ? 0 : (index / maxIndex) * 100;

    const nextSlide = () => {
        if (index < maxIndex) setIndex(index + 1);
    };

    const prevSlide = () => {
        if (index > 0) setIndex(index - 1);
    };

    // Animation variants
    const containerVariants = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.25,
            },
        },
    };

    const fadeUp = {
        hidden: {
            y: 40,
            opacity: 0,
            filter: "blur(6px)",
        },
        show: {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
            transition: {
                duration: 0.8,
                ease: "easeOut",
            },
        },
    };

    const slideLeft = {
        hidden: { opacity: 0, x: -60, filter: "blur(6px)" },
        show: {
            opacity: 1,
            x: 0,
            filter: "blur(0px)",
            transition: { duration: 0.9, ease: "easeOut" },
        },
    };

    const slideRight = {
        hidden: { opacity: 0, x: 60, filter: "blur(6px)" },
        show: {
            opacity: 1,
            x: 0,
            filter: "blur(0px)",
            transition: { duration: 0.9, ease: "easeOut" },
        },
    };

    // Word-by-word animation variants for hero text
    const wordContainer = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.12,
                delayChildren: 0.2,
            },
        },
    };

    const wordVariant = {
        hidden: {
            y: 40,
            opacity: 0,
            filter: "blur(6px)"
        },
        show: {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
            transition: {
                duration: 0.9,
                ease: "easeOut",
            },
        },
    };

    // Split hero text into words
    const line1 = "We craft luxury homes".split(" ");
    const line2 = "with care and precision".split(" ");
    return (
        <>
            <Header />


            <section
                className="about-hero container-fluid py-5"
                id="about-section"
                ref={sectionRef}
                style={{ overflowX: "hidden" }}
            >
                <div className="container h-100 py-5 px-lg-0">
                    <motion.div
                        className="about-content py-5 row h-100"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.4 }}
                    >
                        <div className="col-lg-7 px-lg-0 d-flex flex-column left-side">
                            <motion.h1
                                className="display-3"
                                variants={wordContainer}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: false, amount: 0.6 }}
                            >
                                {line1.map((word, i) => (
                                    <motion.span
                                        key={`line1-${i}`}
                                        variants={wordVariant}
                                        style={{ display: 'inline-block', marginRight: '0.35em' }}
                                    >
                                        {word}
                                    </motion.span>
                                ))}
                                <br />
                                {line2.map((word, i) => (
                                    <motion.span
                                        key={`line2-${i}`}
                                        variants={wordVariant}
                                        style={{ display: 'inline-block', marginRight: '0.35em', color: "#6b6b6b" }}
                                    >
                                        {word}
                                    </motion.span>
                                ))}
                            </motion.h1>
                        </div>

                        <div className="col-lg-5 px-lg-0 d-flex justify-content-end flex-column right-side">
                            <motion.p
                                className="about-subtext pertili-font"
                                variants={fadeUp}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: false, amount: 0.4 }}
                            >
                                Every home is thoughtfully crafted with uncompromising attention to detail. From design to execution, we blend luxury, precision, and quality to create living spaces that reflect timeless elegance and lasting value. <span>We believe true luxury lies in thoughtful design and meticulous craftsmanship. Every Vessella home is created with care and precision, ensuring comfort, functionality, and refined living for generations to come.
                                </span>
                            </motion.p>
                        </div>
                    </motion.div>
                </div>

                <button
                    className="explore-btn"
                    onClick={() =>
                        document
                            .getElementById("projects-section")
                            .scrollIntoView({ behavior: "smooth" })
                    }
                >
                    <span className="explore-arrows">
                        <svg viewBox="0 0 4 8">
                            <path d="M2.86 0.89L1.15 3.89L2.86 6.9" />
                        </svg>
                        <svg viewBox="0 0 4 8">
                            <path d="M2.86 0.89L1.15 3.89L2.86 6.9" />
                        </svg>
                        <svg viewBox="0 0 4 8">
                            <path d="M2.86 0.89L1.15 3.89L2.86 6.9" />
                        </svg>
                    </span>

                    <span className="explore-text geist-font">EXPLORE</span>
                </button>
                <div className="hero-blue-overlay" />
            </section>


            <ProjectNew />

            <motion.section
                className="about-section-three py-5 my-5"
                variants={containerVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: false, amount: 0.2 }}
                style={{ overflowX: "hidden" }}
            >
                <div className="container">
                    {/* Top label */}
                    <motion.div className="about-label mb-4" variants={fadeUp}>
                        <span className="about-dot"></span>
                        <span className="about-label-text">Our Capabilities</span>
                    </motion.div>

                    <motion.h2
                        className="about-heading mb-5"
                        variants={wordContainer}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.6 }}
                    >
                        {capabilitiesHeading.map((word, i) => (
                            <motion.span
                                key={`cap-word-${i}`}
                                variants={wordVariant}
                                style={{
                                    display: "inline-block",
                                    marginRight: "0.35em",
                                }}
                            >
                                {word}
                            </motion.span>
                        ))}
                    </motion.h2>


                    <div className="row g-4">
                        <motion.div className="col-md-4" variants={fadeUp}>
                            <div className="about-card">
                                <img src={TrustIcon} className="mb-3" style={{ width: "50px" }} alt="Trust Icon" />
                                <p>We uphold the highest standards of integrity and business ethics, ensuring every decision reflects fairness, transparency, and unwavering respect for our valued customers and stakeholders.
                                </p>
                            </div>
                        </motion.div>

                        <motion.div className="col-md-4" variants={fadeUp}>
                            <div className="about-card">
                                <img src={EmpathyIcon} className="mb-3" style={{ width: "50px" }} alt="Empathy Icon" />
                                <p>We create an exceptional work environment designed to inspire, energize, and elevate our people—unlocking their full potential every day.
                                </p>
                            </div>
                        </motion.div>

                        <motion.div className="col-md-4" variants={fadeUp}>
                            <div className="about-card">
                                <img src={CreativityIcon} className="mb-3" style={{ width: "50px" }} alt="Creativity Icon" />
                                <p>We empower forward-looking minds that challenge convention, spark innovation, and deliver superior solutions and lasting impact.</p>
                            </div>
                        </motion.div>
                    </div>
                </div>


            </motion.section>
        </>

    );
}
